import * as utils from './utils';

const provider = {
  getLanguageLevels: _ => utils.get(`language_levels?_start=0&_end=999&_sort=id`)
};

export default provider;
